import { TrelloWindow } from '@trello/window-types';

import { getDefaultLocale } from './getDefaultLocale';
import { getSupportedLocales } from './getSupportedLocales';

declare const window: TrelloWindow;

function getCookie(name: string) {
  const value = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split('=')?.[1];

  if (!value) {
    return;
  }

  return decodeURIComponent(value);
}

export function getPreferredLocale() {
  const langOverride = getCookie('langOverride');

  if (langOverride && getSupportedLocales().includes(langOverride)) {
    return langOverride;
  }

  const token =
    getCookie('token') ?? getCookie('token2999') ?? getCookie('token3000');

  if (!token) {
    return getDefaultLocale();
  }

  const memberId = token.split('/')[0];
  // eslint-disable-next-line @trello/ban-identifiers
  const localStorageValue = window.localStorage.getItem(`locale-${memberId}`);
  const memberPref = localStorageValue ? JSON.parse(localStorageValue) : null;

  if (memberPref && getSupportedLocales().includes(memberPref)) {
    return memberPref;
  }

  return getDefaultLocale();
}
